import { Button } from '@mui/material';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { renderField, required } from '../../common/helpers/form-validations';
import UploadImage from '../../common/uploadImage';

function CategoryForm(props) {
  const {
    handleSubmit, onButtonClick, categoryText, handleChangeLogo,
    logoImage, invalid, submitSucceeded, pristine, buttonSaveText
  } = props;

  const onSubmit = (formData) => {
    onButtonClick(formData);
  };

  return (
    <div>
      <form
        form="categoryForm"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-5">
            <h6>{categoryText}</h6>
            <div className="form-group">
              <label htmlFor="categoryName">
                Category name <span className="validation-icon">*</span>
              </label>
              <Field
                id="categoryName"
                className="form-control"
                placeholder="Category Name"
                component={renderField}
                name="categoryName"
                validate={[required]}
              />
            </div>
            <div className="form-group upload-input-img">
              <label htmlFor="web">
                Upload Logo <span className="validation-icon">*</span>
              </label>
              <br />
              <UploadImage
                handleChangeLogo={handleChangeLogo}
                logoImage={logoImage}
              />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-7">
              <div className="form-group mt-1">
                <Button
                  type="submit"
                  className="btn btn-red"
                  disabled={invalid || submitSucceeded || pristine}
                >
                  {buttonSaveText}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'categoryForm',
});

export default withForm(CategoryForm);
